import Button from "../General/Button"
import Input from "../General/Input";
import { useDispatch, useSelector } from "react-redux";
import urls from "../../constants/api-endpoints"
import helpers from "../../utils/helpers";
import accessToken from "../../utils/access-token";
import Axios from "../../utils/axios";
import { useFormik } from "formik";
import BidCreateSchema from "../../validations/Bid";
import { showConfirmationBox } from "../../store/ConfirmationSlice";
import { useState, useEffect } from "react";
import { setSnackBar } from "../../store/ToastSlice";
import styles from "../../styles/APIDetails/[slug].module.css";
import { MixPanelConstants } from "../../constants/MixPanelEvents";
import { MixpanelTracking } from "../../MixPanel";

function PDPDealCard({ data, resetCard, user, openDialog }: any) {    
    const dispatch = useDispatch();
    const { confirm, from } = useSelector((state : any) => state.confirmation)
    const [payload, setPayload] : any = useState({})
    const [shrinkedList, setShrinkedList] = useState(true);

    const initialValues = {
        bid_quantity : null
    }

    const { values, errors, handleSubmit, handleBlur, handleChange, touched, resetForm } = useFormik({
		initialValues: initialValues,
        validationSchema : BidCreateSchema,

		onSubmit: (values, action) => {
            let payload : any = {
                unit : data.minimum_quantity_unit_details.id, 
                deal : data.id 
            }
			payload = {...payload, ...values}
            setPayload(payload);
            const confirmationData = {
                from : 'PDPDealCard',
                details : `You are placing a bid for ${values.bid_quantity} ${data.minimum_quantity_unit_details.name} of ${data.product_details.product_details.name} (${data.product_details.product_details.cas_number}).`
            }
            dispatch(showConfirmationBox(confirmationData));
		}
	});

    useEffect(() => {
        if(confirm && from === 'PDPDealCard' && data.id == payload.deal) {
            submitBid(payload);
        }
    }, [confirm, from])

    const submitBid = (payload : any) => {
        const mixPanelData : any = {
            bidQuantity : payload.bid_quantity,
            dealID : payload.deal
        }

        const endPoint = helpers.getAPIEndpoint(urls.bidCreate);
        const headers = {
            'Authorization' : `Bearer ${accessToken.getAccessToken()}`
        }

        const successHandler = (response : any) => {
            resetForm();
            resetCard();
            dispatch(setSnackBar({
                color : 'success',
                message : 'Your bid has been successfully made!'
            }));
            mixPanelData['status'] = MixPanelConstants.SUCCESS;
            
            MixpanelTracking.getInstance().bid(mixPanelData);
        }

        const errorHandler = (error : any) => {
            console.log(error);
            dispatch(setSnackBar({
                color : 'error',
                message : error.response.data.detail[0]
            }));
            mixPanelData['status'] = MixPanelConstants.FAILED
            mixPanelData['reason'] = error.response.data.detail[0];
            MixpanelTracking.getInstance().bid(mixPanelData);
        }

        Axios.requestPOST(
            endPoint,
            payload,
            headers,
            successHandler,
            errorHandler
        )
    }

    return (
        <div style={{ border: '0.5px solid rgba(170, 170, 170, 0.5)' }} 
            className='bg-white px-3 pt-3 pb-4 mb-4 w-[100%] rounded-[5px]'
        >

            <div className="">
                {
                    !user.isLoggedIn ? 
                    <div className={`${styles.BlurSmallImage} h-14 mb-3`}></div> : 
                    <div className="name__date flex justify-between items-start mb-3">
                        <div className={`price__bid flex items-center ${data.deal_price ? 'justify-between' : 'justify-end'}`}>
                            {
                                data.deal_price &&
                                <div>
                                    <h1 className="text-2xl font-bold text-theme-black">$
                                        <span>
                                            { data.deal_price }
                                            <span className="font-light text-theme-black" style={{ fontSize: 12 }}> / {data.deal_quantity_unit_details.name} </span>
                                        </span>
                                    </h1>
                                    <small className="text-theme-black opacity-70 block" style={{ marginTop: -5 }}> Deal Price </small>
                                </div>
                            }
                        </div>

                        <div className="date text-right">
                            <small className={`block text-theme-black font-semibold pt-2 ${data.days_left.days <= 5 && 'text-[#A9342E]'}`} style={{ fontSize: '0.9rem' }}> {data.deal_closure_date} </small>
                            <small className='block text-theme-black opacity-70'> Bid End Date </small>
                        </div>
                    </div>
                }
            </div>

            <div className="progress-details px-3 py-2 pt-4 mt-1 mb-3 bg-white" style={{ borderRadius: 9 }}>
                <div className="quantity__price flex justify-between items-end">
                    <div>
                        <p className="text-theme-black font-semibold leading-3" style={{ fontSize: '0.9rem' }}>{data.minimum_bid_quantity} {data.minimum_quantity_unit_details.name}</p>
                        <small className="text-theme-black" style={{ fontSize: 12 }}>Min. Bid QTY</small>
                    </div>

                    <div className="text-right">
                        <p className="text-theme-black font-semibold leading-3" style={{ fontSize: 19 }}>{data.deal_quantity}
                            <span style={{ fontSize: 13 }} className="font-normal"> {data.deal_quantity_unit_details.name} </span>
                        </p>
                        <small className="text-theme-black" style={{ fontSize: 12 }}>Deal Activation QTY</small>
                    </div>
                </div>

                <div className="progress mt-2">
                    <div className="w-full" style={{ width: '100%', height: '7px', borderRadius: 9, background: 'rgba(219, 107, 43, 0.15)' }}>
                        <div
                            className="text-right"
                            style={{ background : 'rgba(219, 107, 43, 0.63)', width: `${data.total_commitment_in_percentage.commited}%`, height: '7px', borderTopLeftRadius: 9, borderBottomLeftRadius: 9 }}>
                            {/* {
                                data.total_commitment_in_percentage.commited > 0 &&
                                <div className="opacity-40" style={{ transform: 'translate(1.5px, -12px)' }}>|</div>
                            } */}
                        </div>
                    </div>
                </div>

                <div className='flex justify-end mt-2'>
                    <small className="text-theme-black"> <span className="font-semibold opacity-100">{data.total_commitment_in_percentage.commited}%</span> <span className="opacity-80">Completed</span> </small>
                </div>
            </div>
            

            <div className="flex justify-between py-2 rounded-[2px] px-2 lg:py-2 bg-[#F7F7F7] mb-[6px]">
                <p className="text-[14px] lg:w-[48%]">Pharmacopeia grades</p>
                <p className="text-[14px] font-[700]"> 
                    {
                        data.product_details.pharmacopoeia_grade_list.map((certificate : any, index : number) => (
                            <span key={index}>
                                { certificate.name }{ index === data.product_details.pharmacopoeia_grade_list.length - 1 ? '' : ' / ' }
                            </span>
                        ))  
                    } 
                </p>
            </div>

            <div className="flex justify-between py-2 rounded-[2px] px-2 lg:py-2 bg-[#F7F7F7] mb-[13px]">
                <p className="text-[14px] lg:w-[48%]">Quality certificates</p>
                <p className="text-[14px] font-[700]"> 
                    {
                        data.product_details.certificate_list.map((certificate : any, index : number) => (
                            <span key={index}>
                                { certificate.name }{ index === data.product_details.certificate_list.length - 1 ? '' : ' / ' }
                            </span>
                        ))  
                    } 
                </p>
            </div>

            {   
                !user.isLoggedIn ?
                <div className={`${styles.blurImage} flex justify-between items-center px-4 py-4 mt-1`}>
                    <p className="text-white text-sm"> Login to see the Deal</p>
                    <Button 
                        onClick={() => dispatch(openDialog(true))} 
                        destinationEvent = 'Login/Register popup Opened'
                        styles="bg-theme-orange text-white px-5 h-10 font-light text-sm">
                            Login/Register
                    </Button>
                </div> :
                <form onSubmit={handleSubmit}>
                    <div className="input rounded-[4px] p-3 mt-3" style={{ background: 'rgba(219, 107, 43, 0.15)' }}>
                        <div className="flex items-start justify-between">
                            <div className="w-[70%]">
                                    <Input 
                                        outerProperties = 'rounded border border-[#00000033] h-[39px]'
                                        properties = 'placeholder:text-theme-black placeholder:text-[12px] h-[37px]'
                                        background = 'transparent'
                                        placeholder = 'Enter Your Bid QTY'
                                        suffix = {
                                            <div className="w-[40px] h-[39px] flex items-center justify-center border-l border-l-[#C8BAB2]">
                                                KG
                                            </div>
                                        }
                                        onChange={handleChange}
                                        name='bid_quantity'
                                        value={values.bid_quantity}
                                        onBlur={handleBlur}
                                        error={errors.bid_quantity}
                                        touched={touched.bid_quantity}
                                        maxLength={20}
                                    />
                            </div>
                            <Button 
                                styles = 'bg-[#407BFF] text-white w-[28%] text-[12px]'
                                height = {38}
                                destinationEvent = 'Confirmation popup Opened'
                                borderRadius = {3}
                            > 
                                Bid Now 
                            </Button>
                        </div>
                        <div className="text-theme-black flex justify-between justify-between">
                            {
                                data.payment_terms && 
                                <div className="flex items-center w-[40%] mt-2">
                                    <img className="w-[15px] mr-2" src="/APIDetails/Card.svg" alt="" />  
                                    <small className="text-[12px]"> {data.payment_terms} </small>      
                                </div>
                            }

                            {
                                data.delivery_days && 
                                <div className={`flex items-center w-[60%] mt-2 ${data.payment_terms && 'justify-end'}`}>
                                    <img className="w-[15px] mr-2" src="/APIDetails/Truck.svg" alt="" />  
                                    <small className="text-[12px]"> {data.delivery_days} days after order placement </small>      
                                </div>
                            }
                        </div>
                    </div>
                </form>
            }
        </div>
    )
}

export default PDPDealCard